module.exports = __webpack_public_path__ + "img/jiayou.c77c1832.png";